<article
  class="group brandbot-card flex flex-col h-full rounded-2xl overflow-hidden cursor-pointer"
  [style.--icon-accent]="accentHex()"
>
  <!-- Top: icon chip + navigation affordance (chevron slides in on hover) -->
  <div class="px-5 pt-4 pb-2 flex items-start justify-between gap-4">
    <span class="info-icon-chip stat-card-icon shrink-0">
      <primecontrol-svg-icon
        class="icon-size-4"
        [svgIcon]="metric().iconName"
      ></primecontrol-svg-icon>
    </span>
    <primecontrol-svg-icon
      class="icon-size-4 shrink-0 text-[color:var(--text-subtitle)] opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200"
      [svgIcon]="'heroicons_solid:chevron-right'"
    ></primecontrol-svg-icon>
  </div>

  <!-- The number is the hero: eyebrow title above, counted-up total. Sized one
       step below the stat-card filter tiles (text-2xl vs text-3xl) so the
       dashboard summary reads a touch quieter than the filter tiles. -->
  <div class="px-5 pb-3 flex flex-col gap-1">
    <p
      class="text-pc-eyebrow font-bold uppercase tracking-widest leading-tight text-slate-500 dark:text-neutral-500"
    >
      {{ metric().title | translate }}
    </p>
    <p
      class="text-2xl font-bold tracking-tight tabular-nums leading-none text-[color:var(--text-title)]"
    >
      {{ displayTotal() }}
    </p>
  </div>

  <!-- Trend sparkline (accent-tinted area + line; see ts for the data source).
       The slot keeps its height with no series so the grid stays even. -->
  <div
    class="relative mt-auto h-7 -mb-px"
    (mousemove)="onSparkMove($event)"
    (mouseleave)="hoverIndex.set(null)"
  >
    @if (sparkline(); as spark) {
      <svg
        class="block w-full h-full"
        viewBox="0 0 100 32"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path [attr.d]="spark.area" fill="var(--icon-accent)" opacity="0.1"></path>
        <polyline
          [attr.points]="spark.line"
          fill="none"
          stroke="var(--icon-accent)"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          vector-effect="non-scaling-stroke"
        ></polyline>
      </svg>
      <!-- Hover read-out: a dot on the hovered month and its name + count above
           it. HTML, not SVG: the viewBox is stretched, so an SVG circle would
           render as an ellipse. The label stays inside the card at the edges. -->
      @if (hoveredPoint(); as hp) {
        <span
          class="pointer-events-none absolute w-2 h-2 -ml-1 -mt-1 rounded-full bg-[color:var(--icon-accent)] ring-2 ring-white dark:ring-neutral-900"
          [style.left.%]="hp.left"
          [style.top.%]="hp.top"
        ></span>
        <span
          class="pointer-events-none absolute bottom-full mb-1 whitespace-nowrap rounded-md bg-neutral-900/90 px-1.5 py-0.5 text-pc-eyebrow font-medium text-white tabular-nums dark:bg-neutral-100 dark:text-neutral-900"
          [style.left.%]="hp.left"
          [style.transform]="
            hp.left < 15 ? 'none' : hp.left > 85 ? 'translateX(-100%)' : 'translateX(-50%)'
          "
        >
          {{ hp.label }} · {{ hp.value }}
        </span>
      }
    }
  </div>

  <!-- Footer: primary metric + optional delta -->
  <div
    class="px-5 py-2 border-t border-neutral-200/60 dark:border-white/10 flex items-center justify-between gap-2 text-pc-label text-[color:var(--text-subtitle)]"
  >
    @if (metric().metrics?.[0]) {
      <span class="inline-flex items-baseline gap-1 min-w-0 truncate">
        <span class="font-semibold tabular-nums text-[color:var(--text-title)]">{{
          metric().metrics[0].value
        }}</span>
        <span class="opacity-70 truncate">{{ metric().metrics[0].displayText | translate }}</span>
      </span>
    } @else {
      <span class="opacity-70">&nbsp;</span>
    }

    @if (delta(); as d) {
      <span
        class="inline-flex items-center gap-0.5 font-semibold tabular-nums shrink-0 {{ d.classes }}"
        [title]="'MONTHLY_DELTA_TOOLTIP' | translate: d.tooltipParams"
      >
        <primecontrol-svg-icon class="icon-size-3.5" [svgIcon]="d.icon"></primecontrol-svg-icon>
        {{ d.label }}
      </span>
    }
  </div>
</article>
